var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M.007 94.335L94.405-.063l5.586 5.586L5.593 99.921z","key":0}),React.createElement("path",{"d":"M.007 5.665L5.593.079l94.398 94.398-5.586 5.586z","key":1})]);
}

IconClose.defaultProps = {"className":"icon close_","viewBox":"0 0 100 100"};

module.exports = IconClose;

IconClose.default = IconClose;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-close.svg
// module id = 522
// module chunks = 0